export enum LibraryFilterCardsBy {
  Default,
  Sharing,
  Private,
  My,
  CoParents
}

export enum LibrarySortCardsBy {
  Default,
  DateAsc,
  DateDesc,
  TitleAsc,
  TitleDesc
}

export enum LibraryFieldType {
  Name,
  PhoneNumber,
  EmailAddress,
  Address,
  AddressCity,
  AddressState,
  AddressZip
}
